<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-minus-circle-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm9.625 20c.76 0 1.375.448 1.375 1v2c0 .552-.616 1-1.375 1h-19.25c-.76 0-1.375-.448-1.375-1v-2c0-.552.616-1 1.375-1h19.25z"/></svg>
</template>
<script>

export default {
  name: 'IconMinusCircleFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
